/**
 * Status Controller
 */
(function(angular) {
    'use strict';

    var app = angular.module('asDemandMgr');

    app.controller('CampaignStatusController', [
        '$scope',
        '$timeout',
        'campaignApi',
        function($scope, $timeout, campaignApi) {
            // init values
            $scope.campaign = {};
            $scope.form = {
                datetime:  parseInt(moment().format('x'))
            };

            /**
             * Fetch list data from server
             */
            $scope.fetch = function() {
                $scope.loading = true;

                campaignApi
                    .getStatus(campaignId, $scope.form.datetime)
                    .then(
                        function(data) {
                            $scope.campaign = data;
                            //$scope.campaign.start = moment($scope.campaign.start).tz("UTC").valueOf();
                            //alert(moment($scope.campaign.start).utcOffset($scope.campaign.calc_user_timezone_offset).format('YYYY-MM-DD HH:mm Z'));
                            $scope.campaign.start = moment($scope.campaign.start).tz($scope.campaign.user_timezone).format('YYYY-MM-DD HH:mm Z');
                            $scope.campaign.end = moment($scope.campaign.end).tz($scope.campaign.user_timezone).format('YYYY-MM-DD HH:mm Z');
                            $scope.campaign.calc_datetime_user_tz = moment.unix($scope.campaign.calc_datetime_user_tz/1000).tz($scope.campaign.user_timezone).format('YYYY-MM-DD HH:mm Z');

                            /*campaignApi.getCampaignStat([data._id], null, moment($scope.form.datetime).format()).then(function(stat) {
                                var campStat = stat[0];
                                $scope.campaign.calc_delivered_imps_total = campStat ? campStat.n_impression : 0;
                                $scope.campaign.calc_remaining_total_goal = $scope.campaign.goal_value - $scope.campaign.calc_delivered_imps_total;

                                // today stats
                                campaignApi.getCampaignStatToday([campStat.cid]).then(function(stat) {
                                    var campStat = stat[0];
                                    $scope.campaign.calc_delivered_imps_today = campStat ? campStat.n_impression : 0;
                                    $scope.campaign.calc_remaining_regular_daily_goal = $scope.campaign.value_regular_daily_goal - $scope.campaign.calc_delivered_imps_today;
                                    $scope.campaign.calc_remaining_allowed_daily_goal = $scope.campaign.calc_remaining_regular_daily_goal * $scope.campaign.value_pacing;

                                });


                            });*/


                            $scope.loading = false;
                        },
                        function() {
                            alert("Fail load status")
                            $scope.loading = false;
                        }
                    );
            };


            /**
             * open a Campaign creating/editing form
             * @param campaignId
             */
            $scope.openCampaignForm = function(campaignId) {
                window.location.href = '/#!/demandmgr/campaign/edit?id=' + campaignId;
            };

            $scope.fetch();
        },
    ]);
})(window.angular);
